import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { useHelpWidgetContext } from "../../context/HelpWidgetContext";

export const HeaderResizeButton = () => {
  const { isExpanded, expandWidget, collapseWidget } = useHelpWidgetContext();

  const handleClick = () => {
    if (isExpanded) {
      collapseWidget();
    } else {
      expandWidget();
    }
  };

  return (
    <TippyV2
      content={
        isExpanded
          ? t("help_widget.tooltip.collapse_widget")
          : t("help_widget.tooltip.expand_widget")
      }
    >
      <button
        type="button"
        onClick={handleClick}
        className="hover:bg-secondary text-light flex size-6 items-center rounded-full p-1"
      >
        <Icon type="sw-resize" useWithFillCurrentColor size={16} />
      </button>
    </TippyV2>
  );
};
